// Copyright (c) 2016 Deere & Company

import {
    selectAllDealersOnLoad,
    selectAllMassChannelCustomerFollowupDealers,
    selectMassChannelCustomerFollowupDealer
} from './select-dealer';
import {createMassChannelCustomerFollowUpReport} from './create-report';
import {sharedActionCreators} from '../../shared/action-creators';
export default {
    createMassChannelCustomerFollowUpReport,
    selectAllDealersOnLoad,
    selectAllMassChannelCustomerFollowupDealers,
    selectMassChannelCustomerFollowupDealer,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/action-creators/index.js